import React from 'react';

const FACEBOOK_PAGE_URL = 'https://www.facebook.com/people/Cre8it/61557070354740/?locale=da_DK';
const CRE8IT_LOGO = 'https://assets.auxodev.dk/cdn-cgi/image/width=200,quality=90,format=auto/assets/83c5e513-aae5-4fee-8b74-db63d3cee346/image_0a1ff1c3.png';
const COVER_PHOTO = 'https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/83c5e513-aae5-4fee-8b74-db63d3cee346/image_9a812938.png';

export default function FacebookFeedMockup() {
  return (
    <div className="relative h-[530px] sm:h-[570px] w-full overflow-hidden rounded-[2rem] bg-white pt-5 flex flex-col font-sans select-none shadow-xl border border-gray-300/80">
      {/* Main Content: Cover Photo, Logo, Description and Facebook Link */}
      <div className="relative flex-1 w-full bg-white overflow-y-auto overflow-x-hidden flex flex-col justify-between text-left text-gray-900 pb-5">
        
        <div>
          {/* Cover Photo */}
          <div className="relative h-36 sm:h-40 w-full bg-gradient-to-r from-[#245b53] via-[#1a443e] to-[#0e2723] overflow-hidden">
            <img
              src={COVER_PHOTO}
              alt="Cre8it Facebook Cover"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
          </div>

          {/* Profile Section: Logo & Titles */}
          <div className="px-4 relative">
            {/* Logo */}
            <div className="flex items-end justify-between -mt-10 mb-3">
              <div className="w-20 h-20 rounded-full bg-white p-1.5 ring-4 ring-white shadow-lg flex items-center justify-center overflow-hidden">
                <img
                  src={CRE8IT_LOGO}
                  alt="Cre8it Logo"
                  className="w-full h-full object-contain"
                />
              </div>
              <a
                href={FACEBOOK_PAGE_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="px-3.5 py-1.5 bg-[#1877F2] text-white rounded-lg text-xs font-bold hover:bg-[#166fe5] transition-all flex items-center gap-1.5 shadow-sm active:scale-95 cursor-pointer"
              >
                <i className="fa-brands fa-facebook text-sm" />
                <span>Følg side</span>
              </a>
            </div>

            {/* Page Name & Subtitle */}
            <div className="space-y-1">
              <div className="flex items-center gap-1.5">
                <h3 className="text-lg font-black text-gray-950 tracking-tight">Cre8it</h3>
                <i className="fa-solid fa-circle-check text-[#1877F2] text-sm" />
              </div>
              <p className="text-xs font-bold text-[#245b53]">
                FOLIE - DESIGN - SOLFILM
              </p>
            </div>

            {/* Meta Info */}
            <div className="mt-3 p-3 bg-gray-50 rounded-xl border border-gray-200/70 text-xs text-gray-700 leading-relaxed">
              <div className="flex flex-wrap items-center gap-y-1 gap-x-3 text-[11px] text-gray-500">
                <span className="flex items-center gap-1 font-semibold text-gray-700">
                  <i className="fa-solid fa-users text-[#1877F2]" />
                  844 følgere
                </span>
                <span>·</span>
                <span className="flex items-center gap-1">
                  <i className="fa-solid fa-location-dot text-[#245b53]" />
                  Rødding, Danmark
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Action Link to Facebook */}
        <div className="px-4 pt-4 mt-auto">
          <a
            href={FACEBOOK_PAGE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center gap-2 w-full py-3 px-4 rounded-xl bg-[#1877F2] hover:bg-[#166fe5] active:scale-95 text-white font-bold text-xs sm:text-sm shadow-md transition-all cursor-pointer group"
          >
            <i className="fa-brands fa-facebook-f text-base" />
            <span>Besøg Cre8it på Facebook</span>
            <i className="fa-solid fa-arrow-up-right-from-square text-xs group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
          </a>
          <p className="text-[10px] text-gray-400 text-center mt-2">
            Åbner i en ny fane på facebook.com
          </p>
        </div>

      </div>

    </div>
  );
}
